import { render, staticRenderFns } from "./iconStar.vue?vue&type=template&id=b112230c"
import script from "./iconStar.vue?vue&type=script&lang=js"
export * from "./iconStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports